import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";
const handleFetchModules = async () => {
  const uri = `v1/modules`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateModule = async (data: any) => {
  const uri = `v1/modules`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateModule = async ({ data, _id }: any) => {
  const uri = `v1/modules/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteModule = async ({ _id }: any) => {
  const uri = `v1/modules/${_id}`;
  const response = deleteData({ uri });
  return response;
};

export {
  handleFetchModules,
  handleCreateModule,
  handleUpdateModule,
  handleDeleteModule,
};
